import React from 'react';
import { FormProps } from '../../types/form-types';
import { useForm } from '../../hooks/useForm';

const Form: React.FC<FormProps> = ({
  children,
  onSubmit,
  initialValues = {},
  validationRules = {},
  style = {},
  className = ''
}) => {
  const { formContext } = useForm({
    initialValues,
    validationRules,
    onSubmit
  });

  const defaultStyle: React.CSSProperties = {
    width: '100%',
    ...style
  };

  return (
    <div style={defaultStyle} className={className}>
      {typeof children === 'function' ? children(formContext) : children}
    </div>
  );
};

export default Form;

